<template>
  <div>
    <el-dialog
      title="新增服务"
      :visible="newDialogVisible"
      width="50%"
      @close="handleCloseAdd('ruleForm')"
    >
      <div class="content">
        <el-form
          ref="ruleForm"
          :rules="rules"
          :model="ruleForm"
          label-width="120px"
        >
          <el-form-item label="服务名称" prop="title">
            <el-input
              size="small"
              v-model="ruleForm.title"
              placeholder="请输入内容"
              style="width: 40%"
            />
          </el-form-item>
          <el-form-item label="服务介绍" prop="serviceIntroduction">
            <el-input
              size="small"
              v-model="ruleForm.serviceIntroduction"
              placeholder="请输入内容"
              style="width: 40%"
            />
          </el-form-item>
          <el-form-item label="服务类目" prop="categoryId">
            <el-cascader
              v-model="ruleForm.categoryId"
              :props="{
                label: 'title',
                value: 'id',
                children: 'atCategoryInfos',
              }"
              size="small"
              @change="changeCascader"
              :options="typeList"
              clearable
              :show-all-levels="false"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="服务定价" prop="startPrice">
            <el-input
              size="small"
              v-model="ruleForm.startPrice"
              placeholder="请输入内容"
              style="width: 40%"
            />
          </el-form-item>
          <el-form-item label="付款类型" prop="isOnce">
            <el-select
              style="flex: 1"
              v-model="ruleForm.isOnce"
              clearable
              size="small"
              placeholder="请选择"
            >
              <el-option
                v-for="item in isOnceList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="定金"
            prop="deposit"
            v-if="ruleForm.isOnce === 0"
          >
            <el-input
              size="small"
              v-model="ruleForm.deposit"
              placeholder="请输入定金"
              style="width: 40%"
            />
          </el-form-item>
          <el-form-item label="排序" prop="sort">
            <el-input-number
              style="width: 50%"
              v-model="ruleForm.sort"
              :min="1"
              placeholder="排序"
              size="small"
            ></el-input-number>
          </el-form-item>

          <el-form-item label="服务封面图" prop="imageUrl">
            <el-upload
              class="avatar-uploader"
              :action="upLoadApi"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :headers="uploadHeaders"
            >
              <img
                v-if="ruleForm.imageUrl"
                :src="ruleForm.imageUrl"
                class="avatar"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="服务头图照片" prop="imageUrlPro">
            <el-upload
              class="avatar-uploader avatar-uploader-img-list"
              :action="upLoadApi"
              :on-success="handleAvatarSuccessPro"
              :on-remove="handleRemove"
              :file-list="fileList"
              list-type="picture"
              :limit="3"
              :headers="uploadHeaders"
            >
              <img
                v-if="ruleForm.imageUrlPro"
                :src="ruleForm.imageUrlPro"
                class="avatar"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <!-- 富文本 -->
          <el-form-item label="服务详情" prop="content">
            <div
              ref="editorDom"
              style="text-align: left; margin-top: 10px"
            ></div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseAdd('ruleForm')">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Editor from "wangeditor";
import serveApi from "../serve.js";
export default {
  data() {
    return {
      newDialogVisible: false,
      // 富文本对象
      editor: null,
      // 表单
      ruleForm: {
        // 服务名称
        title: "",
        // 服务介绍
        serviceIntroduction: "",
        // 排序
        sort: "",
        // 服务类目
        categoryId: "",
        // 服务定价
        startPrice: "",
        // 付款类型
        isOnce: "",
        // 定金
        deposit: "",
        // 服务封面图
        imageUrl: "",
        // 服务头照
        imageUrlPro: "",
        // 服务详情
        content: "",
      },
      // 规则
      rules: {
        title: { required: true, message: "服务名称", trigger: "blur" },
        serviceIntroduction: {
          required: true,
          message: "服务介绍",
          trigger: "blur",
        },
        categoryId: { required: true, message: "服务类目", trigger: "change" },
        sort: { required: true, message: "排序", trigger: "change" },
        startPrice: { required: true, message: "服务价格", trigger: "blur" },
        deposit: { required: true, message: "定金", trigger: "blur" },
        isOnce: { required: true, message: "付款类型", trigger: "change" },
        imageUrl: { required: true, message: "服务封面图", trigger: "change" },
        imageUrlPro: { required: true, message: "服务头图", trigger: "change" },
        content: { required: true, message: "服务详情", trigger: "blur" },
      },
      // 商品图
      dialogImageUrl: [],
      // 轮播图
      fileList: [],
      // 服务类目
      typeList: "",
      // 上传地址
      upLoadApi: "",
      // 付款类型
      isOnceList: [
        {
          label: "定金",
          value: 0,
        },
        {
          label: "一口价",
          value: 1,
        },
      ],
      // token
      uploadHeaders: { token: localStorage.getItem("token") },
      // 状态
      newAddEdit: "",
      // 商户ID
      busId: "",
      specificationTable: [
        {
          img: "",
          title: "",
          money: "",
          shareMoney: "",
          sort: "",
        },
      ],
    };
  },
  mounted() {
    // 上传地址拼接
    this.upLoadApi = serveApi.api + "/admin/file/upload";
    // 获取服务列表
    this.getServeList();
  },
  watch: {},
  components: {},
  methods: {
    /**
     * 获取服务列表
     */
    getServeList() {
      let businId = this.$store.state.businServeID;
      let list = [];
      let params = {
        pid: 0,
        // 1：商户服务类型，2：商品类型,3：第三方服务
        type: 1,
      };
      this.$api.production.listAll(params).then((res) => {
        res.data.data.forEach((e) => {
          let data = [];
          e.atCategoryInfos.forEach((obj) => {
            businId.forEach((son) => {
              if (Number(son) === Number(obj.id)) {
                data.push(obj);
              }
            });
          });
          if (!data.length) return;
          let param = {
            id: e.atCategoryInfo.id,
            title: e.atCategoryInfo.title,
            atCategoryInfos: data,
          };
          list.push(param);
        });
        this.typeList = list;
      });
    },
    /**
     * 块级联动
     */
    changeCascader(e) {
      // 取最后一级value值
      this.ruleForm.categoryId = e[1];
    },
    /**
     * 调整每天条数
     */
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    /**
     * 当前页
     */
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    /**
     * 打开弹窗
     */
    openDia(e) {
      this.newDialogVisible = true;

      if (e.id === "") {
        this.newAddEdit = e.id;
        this.busId = e.busId;
      } else {
        this.newAddEdit = e.id;
        this.busId = e.item.busId;
        Object.assign(this.ruleForm, {
          title: e.item.title,
          serviceIntroduction: e.item.serviceIntroduction,
          sort: e.item.sort,
          categoryId: e.item.categoryId,
          startPrice: e.item.startPrice,
          imageUrl: e.item.cover,
          imageUrlPro: e.item.imgList[0],
          isOnce: e.item.isOnce,
          content: e.item.content,
          couponPrice: e.item.couponPrice,
        });
        // 商品图
        this.dialogImageUrl = e.item.imgList;
        // 轮播图
        e.item.imgList.forEach((res, resIndex) => {
          let params = {
            url: res,
            name: "轮播图" + (resIndex + 1),
            response: {
              data: res,
            },
          };
          this.fileList.push(params);
        });
      }
      this.$nextTick(() => {
        // 创建富文本
        this.createEditor();
        if (e.id !== "") {
          this.editor.txt.html(e.item.content);
        }
        this.getServeList();
      });
    },
    /**
     * 关闭弹窗
     */
    handleCloseAdd(formName) {
      // 销毁编辑器
      this.editor.destroy();
      this.dialogImageUrl = [];
      this.fileList = [];
      this.$refs[formName].resetFields();
      this.newDialogVisible = false;
    },
    // 服务规格确认
    submit(e) {
      let params = {
        // 服务id
        id: e.id,
        img: this.specificationTable.img,
        // 服务名称
        title: this.specificationTable.title,
        // 服务类目
        serviceId: e.id,
        money: this.specificationTable.money,
        shareMoney: this.specificationTable.shareMoney,
        status: 1,
        sort: 1,
      };
      this.$api.merchant.serviceSpecAdd(params).then((res) => {
        let item = {
          id: e.id,
          item: res.data.data,
        };
        this.$refs.AddServiceRule.openDia(item);
        this.handleCloseAdd(formName);
        this.$emit("refersh");
      });
    },
    /**
     * 点击确认
     */
    submitForm(formName) {
      (this.ruleForm.content = this.editor.txt.html()),
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let params = {
              // 商户id
              busId: this.busId,
              // 服务产品id
              id: this.newAddEdit,
              // 服务名称
              title: this.ruleForm.title,
              // 店铺介绍
              serviceIntroduction: this.ruleForm.serviceIntroduction,
              // 排序
              sort: this.ruleForm.sort,
              // 服务类目
              categoryId: this.ruleForm.categoryId,
              // 服务价格
              startPrice: this.ruleForm.startPrice,
              // 是否一口价，0不是；1是
              isOnce: this.ruleForm.isOnce,
              // 定金
              deposit: this.ruleForm.isOnce ? "" : this.ruleForm.deposit,
              cover: this.ruleForm.imageUrl,
              imgList: this.dialogImageUrl,
              content: this.ruleForm.content,
            };
            this.$api.merchant.serveListAdd(params).then((res) => {
              this.$message.success("新增成功");
              this.handleCloseAdd(formName);
              this.$emit("refersh");
            });
          } else {
            console.log("error submit!!");
            return false;
          }
        });
    },
    /**
     * 删除
     */
    del(e) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: `已成功删除`,
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    /**
     * 上传规格
     */
    uploadSpec() {
      let fkeyData = "";
      this.specsData.map((e, eindex) => {
        if (eindex === 0) {
          fkeyData = e.id;
        } else {
          fkeyData = fkeyData + "," + e.id;
        }
        return;
      });
      // 清空
      this.specificationTable = [];
      this.resultSku.map((res) => {
        let params = {
          // 商品名KEY
          fkey: fkeyData,
          specImg: "",
          itemName: res.item,
          // 商品值key
          key: res.id,
          storeCount: "",
          price: "",
          costPrice: "",
        };
        this.specificationTable.push(params);
        return;
      });
      console.log(this.specificationTable, "specificationTable");
    },
    /**
     * sku图片选择
     */
    handleSkuImg(res, file) {
      this.specificationTable[this.skuIndex].specImg = res.data;
    },
    /**
     * sku点击储存临时下标
     */
    handleSkuImgI(index) {
      this.skuIndex = index;
    },
    /**
     * 封面图片上传
     */
    handleAvatarSuccess(res, file) {
      this.ruleForm.imageUrl = res.data;
    },
    /**
     * 商品图片上传
     */
    handleAvatarSuccessPro(res, file) {
      this.ruleForm.imageUrlPro = res.data;
      this.dialogImageUrl.push(res.data);
    },
    /**
     * 商品轮播图移除
     */
    handleRemove(file) {
      let img = file.response.data;
      this.dialogImageUrl.map((e, index) => {
        if (e === img) {
          this.dialogImageUrl.splice(index, 1);
        }
        return;
      });
      if (this.dialogImageUrl.length === 0) {
        this.ruleForm.imageUrlPro = "";
      }
    },
    /**
     * 创建富文本
     */
    createEditor() {
      this.editor = new Editor(this.$refs.editorDom);
      this.editor.config.uploadFileName = "file";
      this.editor.config.uploadImgServer = this.upLoadApi;
      // 插入图片前回调函数
      this.editor.config.uploadImgHooks = {
        // 图片上传并返回了结果，想要自己把图片插入到编辑器中
        // 例如服务器端返回的不是 { errno: 0, data: [...] } 这种格式，可使用 customInsert
        customInsert: function (insertImgFn, result) {
          // insertImgFn 可把图片插入到编辑器，传入图片 src ，执行函数即可
          insertImgFn(result.data);
        },
      };
      // 自定义header
      this.editor.config.uploadImgHeaders = {
        token: localStorage.getItem("token"),
      };
      this.editor.create();
    },
  },
};
</script>

<style  scoped>
.first-title {
  display: flex;
  align-items: center;
}

.first-title-icon {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-bottom: 10px;
  margin-right: 10px;
  background: #ff5722;
}

.first-title-word {
  flex: 1;
  box-sizing: border-box;
  padding-bottom: 10px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
  border: 1px dashed #aaa;
  margin-top: 10px;
}

.avatar {
  width: 150px;
  height: 150px;
  display: block;
  margin-top: 10px;
}

.avatar-uploader-img-list {
  /* width: 400px; */
  display: flex;
}

.avatar-uploader-img-list >>> .el-upload--picture {
  margin-right: 20px;
}

.avatar-uploader-img-list >>> .el-upload-list--picture {
  width: 400px;
}

.product-detail {
  margin-top: 20px;
}

.couponPrice {
  display: flex;
  justify-content: start;
  align-items: center;
}

/* 规格属性 */
.first-content {
  box-sizing: border-box;
  padding-top: 10px;
}

.img-upload {
  display: flex;
  flex-direction: column;
}

.img-upload-list {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
}

.avatar-uploader-table {
  display: flex;
  align-items: center;
  padding: 5px 0;
}

.avatar-uploader-img-list {
  width: 400px;
}

.avatar-uploader {
  padding: 5px 0;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  border: 1px dashed #aaa;
  text-align: center;
}

.avatara-uploader-icon {
  font-size: 14px;
  color: #8c939d;
  width: 50px;
  height: 50px;
  line-height: 50px;
  border: 1px dashed #aaa;
  text-align: center;
}

.avatar {
  width: 200px;
  height: 200px;
  display: block;
}

.avatara {
  width: 50px;
  height: 50px;
  display: block;
}

.pro-tile {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  font-size: 16px;
}

.pro-tile-banner {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}

.specs-input >>> .el-input__inner {
  border: none !important;
}

.specs-input >>> .el-input__inner:hover {
  background: rgb(245, 247, 250);
}

.column-box >>> .el-table__cell {
  padding: 0;
}

.column-box >>> .cell {
  padding-left: 0;
  padding-right: 0;
}

.banner-btn {
  display: flex;
  justify-content: flex-end;
  box-sizing: border-box;
  padding: 0 15px 15px;
}

.product-detail {
  margin-top: 20px;
}

.img-upload-box {
  display: flex;
}
.dialog-footer {
  display: flex;
  justify-content: end;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/businessListingServesDialog.vue